import React, { useEffect, useState } from 'react';
import './PDPLargeRooms.scss';
import { BREAKPOINTS } from '../../../constants/breakpoints';

const DESKTOP_WIDTH = BREAKPOINTS.large;

const PDPLargeRooms = ({
  anchor = 'large-rooms',
  icon,
  heading,
  features,
  desktopImage,
  mobileImage,
}) => {
  const [isDesktop, setIsDesktop] = useState(window.innerWidth > DESKTOP_WIDTH);

  useEffect(() => {
    setIsDesktop(window.innerWidth > DESKTOP_WIDTH);
    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleResize = () => setIsDesktop(window.innerWidth > DESKTOP_WIDTH);

  return (
    <>
      {anchor && <a id={anchor} />}
      <div
        className="c-pdp-large-rooms"
        style={{ background: `url(${isDesktop ? desktopImage?.url : mobileImage?.url})` }}
      >
        <div className="c-pdp-large-rooms__content-wrapper">
          <div className="c-pdp-large-rooms__content">
            <img src={icon.url} alt={icon.alt} className="c-pdp-large-rooms__icon" />
            <h4 className="c-pdp-large-rooms__heading h4-right-grotesk color-black">{heading}</h4>
            <div className="c-pdp-large-rooms__features">
              {features.map((feature) => (
                <div className="c-pdp-large-rooms__feature body-1 color-black">{feature}</div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PDPLargeRooms;
